import React from 'react';
import { useEvent } from '../../contexts/EventContext';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const {
    currentEvent
  } = useEvent();
  const baseStyles = 'font-semibold rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center';
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const getVariantStyles = () => {
    const {
      primary,
      secondary,
      accent
    } = currentEvent.colors;
    switch (variant) {
      case 'primary':
        return `shadow-md hover:shadow-lg active:scale-95`;
      case 'secondary':
        return `bg-gray-100 text-gray-900 hover:bg-gray-200 active:scale-95`;
      case 'outline':
        return `bg-transparent border-2 hover:bg-opacity-10 active:scale-95`;
      case 'ghost':
        return `bg-transparent hover:bg-gray-100 active:scale-95`;
      default:
        return '';
    }
  };
  const getBackgroundColor = () => {
    if (variant === 'primary') {
      // For Dubai Active (mint), use dark teal text
      const textColor = currentEvent.id === 'active' ? '#17313a' : 'white';
      return {
        backgroundColor: currentEvent.colors.primary,
        color: textColor
      };
    }
    if (variant === 'outline') {
      // For Dubai Active outline buttons, use teal for better visibility
      const outlineColor = currentEvent.id === 'active' ? '#17313a' : currentEvent.colors.primary;
      return {
        borderColor: outlineColor,
        color: outlineColor
      };
    }
    return {};
  };
  return <button className={`${baseStyles} ${sizeStyles[size]} ${getVariantStyles()} ${fullWidth ? 'w-full' : ''} ${className}`} style={getBackgroundColor()} {...props} data-id="element-4223">
      {children}
    </button>;
}